<template>
  <div class="content">
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <nav-tabs-card>
          <template slot="content">
            <span class="md-nav-tabs-title">el/ka/sy® On-Demand</span>
            <md-tabs class="md-primary" md-alignment="left">
              <md-tab id="tab-products" v-bind:md-label="$t('products')" md-icon="construction">
                <p-s-table
                        showHeader="false"
                        v-bind:data="this.elprocsy"
                        v-bind:dict="this.elprocsyDict"
                        v-bind:actions="this.elProcsyActions"
                ></p-s-table>
              </md-tab>

              <md-tab id="tab-shoppingCart" v-bind:md-label="$t('shopping_cart', { items: shoppingCartLabel })" md-icon="shopping_cart">
                <p-s-table
                        showHeader="false"
                        v-bind:data="this.elprocsyShoppingCart"
                        v-bind:dict="this.elprocsyShoppingCartDict"
                        v-bind:actions="this.elprocsyShoppingCartActions"
                ></p-s-table>
              </md-tab>

              <!-- <md-tab id="tab-OpenOrders" v-bind:md-label="$t('open_positions_title')" md-icon="list_alt">
                <p-s-table
                    showHeader="false"
                    v-bind:data="this.elprocsyOpenOrders"
                    v-bind:dict="this.elprocsyOpenOrdersDict"
                ></p-s-table>
              </md-tab> -->

              <md-tab id="tab-Orders" v-bind:md-label="$t('orders_title')" md-icon="list_alt">
                <p-s-table
                    showHeader="false"
                    v-bind:data="this.elprocsyOrders"
                    v-bind:dict="this.elprocsyOrdersDict"
                    v-bind:actions="this.elprocsyOrdersActions"
                ></p-s-table>
              </md-tab>
            </md-tabs>
          </template>
        </nav-tabs-card>
      </div>
      <md-button class="md-primary" style="margin-left: auto; margin-right: 20px;" v-on:click="sendOrder()">{{ $t('order_button') }}</md-button>
    </div>
  </div>
</template>

<script>
import store from '@/store/index.js';
import api from '@/api/api';
import helper from "../util/helper";
import { NavTabsCard, PSTable } from "@/components";

export default {
  name: "ElProcSy",
  components: {
    NavTabsCard, PSTable
  },
  data () {
    return {
      elprocsy: [],
      elprocsyDict: [
        { key: 'customerArticleNumber', label: 'table_header_customer_article_number', type: 'string'},
        { key: 'customerArticleDescription', label: 'table_header_customer_article_description', type: 'string'},
        { key: 'supplier', label: 'table_header_supplier', type: 'string'},
        { key: 'supplierArticleNumber', label: 'table_header_supplier_article_number', type: 'string'},
        { key: 'quantity', label: 'table_header_quantity', type: 'number'},
        { key: 'basePrice', label: 'table_header_base_price', type: 'price'},
      ],
      elProcsyActions: [
        {
          action: this.addToCart,
          icon: "add_shopping_cart"
        }
      ],
      elprocsyShoppingCartDict: [
        { key: 'customerArticleNumber', label: 'table_header_customer_article_number', type: 'string'},
        { key: 'customerArticleDescription', label: 'table_header_customer_article_description', type: 'string'},
        { key: 'supplier', label: 'table_header_supplier', type: 'string'},
        { key: 'supplierArticleNumber', label: 'table_header_supplier_article_number', type: 'string'},
        { key: 'basePrice', label: 'table_header_base_price', type: 'price'},
        { key: 'quantity', label: 'table_header_quantity', type: 'number'},
      ],
      elprocsyShoppingCartActions: [
        {
          action: this.removeFromCart,
          icon: "remove_shopping_cart"
        }
      ],
      elprocsyOrders: [],
      elprocsyOrdersDict: [
        { key: 'order', label: 'table_header_customer_article_number', type: 'string'},
        { key: 'numberofpositions', label: 'table_header_number_of_articles', type: 'string'},
        { key: 'price', label: 'table_header_total_price', type: 'price'},
        { key: 'orderdate', label: 'table_header_order_date', type: 'date'}
      ],
      elprocsyOrdersActions: [
        {
          action: this.openOrderDetails,
          icon: "search"
        }
      ],
      elprocsyOpenOrders: [],
      elprocsyOpenOrdersDict: [
        { key: 'order', label: 'table_header_order', type: 'string'},
        { key: 'position', label: 'table_header_position', type: 'string'},
        { key: 'customerArticleNumber', label: 'table_header_customer_article_number', type: 'string'},
        { key: 'customerArticleDescription', label: 'table_header_customer_article_description', type: 'string'},
        { key: 'supplier', label: 'table_header_supplier', type: 'string'},
        { key: 'supplierArticleNumber', label: 'table_header_supplier_article_number', type: 'string'},
        { key: 'orderDate', label: 'table_header_order_date', type: 'date'}
      ]
    }
  },
  created() {
    this.pullData();
  },
  computed: {
    shoppingCartLabel () {
      let label = "";

      if (store.state.elprocsyShoppingCart !== null && store.state.elprocsyShoppingCart.length !== 0) {
        label += "(" + store.state.elprocsyShoppingCart.length + ")";
      }
      return label;
    },
    elprocsyShoppingCart() {
      return store.state.elprocsyShoppingCart || [];
    }
  },
  methods: {
    sendOrder() {
      if (store.state.elprocsyShoppingCart === null || store.state.elprocsyShoppingCart.length === 0) {
        this.$notify(
            {
              message: this.$t('shopping_cart_empty_notification'),
              icon: 'info',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger',
              timeout: 10000
            });
      } else {
        api.postElProcSyShoppingCart().then((result) => {
          this.$notify(
              {
                message: this.$t('purchase_success_notification'),
                icon: 'info',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success',
                timeout: 10000
              });

          this.pullData();

          store.commit("setElProcSyShoppingCart", null);
        });
      }
    },
    addToCart(item) {
      if (store.state.elprocsyShoppingCart === null) {
        store.commit("setElProcSyShoppingCart", [item]);
      } else {
        store.state.elprocsyShoppingCart.push(item);
      }

      this.$notify(
              {
                message: this.$t('shopping_cart_added_item_notification'),
                icon: 'info',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success',
                timeout: 10000
              });
    },
    removeFromCart(item) {
      if (store.state.elprocsyShoppingCart !== null) {
        let index = store.state.elprocsyShoppingCart.indexOf(item);
        store.state.elprocsyShoppingCart.splice(index, 1);
      }
    },
    openOrderDetails(item) {
      const id = item.order;
      let routeData = this.$router.resolve({ name: 'el/ka/sy® On-Demand Bestelldetails', params: { id } });
      window.open(routeData.href, '_blank');
    },
    pullData() {
      api.getElProcSy().then((result) => {
        this.elprocsy = result.data;

        api.getElProcSyOrders().then((result) => {
          this.elprocsyOrders = result.data;

          api.getElProcSyOpenOrders().then((result) => {
            this.elprocsyOpenOrders = result.data;

            console.log(this.elprocsyOpenOrders);
          });
        });
      });
    }
  }
};
</script>
